<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="950"
    :retain-focus="false"
    overlay-color="primary"
    overlay-opacity="0.95"
    data-cy="editAvatar-component-popup"
  >
    <v-card v-resize="onResize" style="background: white;" class="border-radius-1">
      <v-row justify="center">
        <AvatarIconEditable v-if="selectedAvatar" :avatar="selectedAvatar" :progress="75"></AvatarIconEditable>
      </v-row>
      <v-card-title class="mt-8">
        <v-row justify="center" class="my-3 title-avatar" data-cy="editAvatar-titlePopUp-row">
          <span v-html="$t('profile.edit_avatar')"></span>
        </v-row>
      </v-card-title>
      <v-card-text class="px-0 mx-0" style="background-color: white">
        <v-card
          elevation="0"
          class="overflow-y-auto px-3 py-0"
          :height="cardHeight"
          style="background: white"
        >
          <v-row class="mx-0 px-0" justify="center">
            <span class="mt-4 title-avatar-types">
              {{ $t('profile.standard_avatars') }}
            </span>
            <v-col cols="12" class="mt-10 py-10" v-if="!standarAvatars" />
            <v-col cols="12" class="py-0 px-3" v-for="(slide, i) in matrix" :key="i" v-else>
              <v-row class="fill-height" align="center" justify="center">
                <v-col cols="4" sm="2" v-for="(avatar, j) in slide" :key="j">
                  <Avatar
                    :avatar="avatar"
                    :selected="isAvatarSelected(avatar)"
                    :key="reload"
                    v-on:active="newSelected"
                  ></Avatar>
                </v-col>
              </v-row>
            </v-col>
            <span class="mt-6 title-avatar-types">
              {{ $t('profile.special_avatars') }}
            </span>
            <v-col cols="12" class="mt-10 py-10" v-if="!standarAvatars" />
            <v-col
              cols="12"
              class="py-0 px-3"
              v-for="(slide, h) in matrixStore"
              :key="'slide-' + h"
              v-else
            >
              <v-row class="fill-height" align="center" justify="center">
                <v-col cols="4" sm="2" v-for="(avatar, k) in slide" :key="'avatarE-' + k">
                  <Avatar
                    :avatar="avatar"
                    :selected="isAvatarSelected(avatar)"
                    :key="reload"
                    v-on:active="newSelected"
                    v-on:toBuy="toBuy"
                  ></Avatar>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-card-text>
      <v-card-actions class="d-flex justify-center py-5">
        <v-row class="ma-0">
          <v-col cols="5" md="4" offset-md="2">
            <v-btn
              color="primary"
              class="no-uppercase border-radius-1"
              large
              block
              outlined
              @click="closeModal"
              :disabled="btnLoading"
              data-cy="editAvatar-exitAction-btn"
            >
              {{ $t('profile.leave') }}
            </v-btn>
          </v-col>
          <v-col cols="7" md="4">
            <v-btn
              class="no-uppercase bg-gradient-primary border-radius-1"
              dark
              large
              block
              @click="updateAvatar"
              :loading="btnLoading"
              data-cy="editAvatar-saveAction-btn"
            >
              {{ $t('profile.save_changes') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AvatarIconEditable from './AvatarIconEditable.vue'
import Avatar from './Avatar.vue'
import UserAvatarService from '../../services/userAvatar'
import AvatarPackService from '../../services/avatarPack'

export default {
  props: {
    dialog: { type: Boolean, default: false },
  },
  components: {
    AvatarIconEditable,
    Avatar,
  },
  data() {
    return {
      avatarPacks: null,
      btnLoading: false,
      cardHeight: 450,
      payAvatars: null,
      reload: 0,
      selectedAvatar: {},
      selectedAvatarFromDB: {},
      standarAvatars: null,
      toBuyAvatars: [],
      userAvatars: null,
      windowSize: {
        x: 0,
        y: 0,
      },
    }
  },
  mounted() {
    this.onResize()
    this.loadData()
  },
  computed: {
    ...mapState({
      user: (state) => state.userData.user,
      stUserAvatar: (state) => state.userData.avatarSelected,
    }),
    matrix() {
      if (!this.standarAvatars) {
        return null
      }
      return this.listToMatrix(this.standarAvatars, 6)
    },
    matrixStore() {
      if (!this.payAvatars) {
        return null
      }
      if (!this.userAvatars) {
        return null
      }
      const store = JSON.parse(JSON.stringify(this.payAvatars))
      const storeAvatars = []
      store.forEach((avatar) => {
        const avatarStore = avatar
        const bought = this.userAvatars.find(
          (userAvatar) => Number(userAvatar.id) === Number(avatar.id)
        )
        avatarStore.active = bought !== undefined
        storeAvatars.push(avatarStore)
      })
      return this.listToMatrix(storeAvatars, 6)
    },
  },
  methods: {
    ...mapActions('userData', ['changeAvatar']),
    closeModal() {
      this.$emit('close')
      this.selectedAvatar = this.stUserAvatar
      this.reload += 1
    },
    getActiveAvatars() {
      AvatarPackService.getAll()
        .then((response) => {
          this.avatarPacks = response.content
          this.setFreeAvatars(response.content)
          this.setPayAvatars(response.content)
        })
        .catch((error) => console.error(error))
    },
    getSelectedAvatar() {
      this.selectedAvatar = this.stUserAvatar
      this.selectedAvatarFromDB = this.stUserAvatar
      this.reload += 1
    },
    getUserAvatars() {
      this.userAvatars = null
      UserAvatarService.getAllByUserAndFree(this.user.id)
        .then((response) => {
          this.userAvatars = response.content
        })
        .catch((error) => console.error(error))
    },
    isAvatarSelected(avatar) {
      const isSelected = this.stUserAvatar && (this.stUserAvatar.id === avatar.id)
      return isSelected
    },
    listToMatrix(list, elementsPerSubArray) {
      const matrix = []
      let i
      let k

      for (i = 0, k = -1; i < list.length; i += 1) {
        if (i % elementsPerSubArray === 0) {
          k += 1
          matrix[k] = []
        }
        matrix[k].push(list[i])
      }
      this.slides = matrix
      return matrix
    },
    async loadData() {
      await this.getUserAvatars()
      await this.getActiveAvatars()
      await this.getSelectedAvatar()
    },
    newSelected(avatarId) {
      this.selectedAvatar = this.searchAvatarSelected(avatarId)
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
      if (this.windowSize.y < 760) {
        if (this.windowSize.y < 650) {
          this.cardHeight = 250
        } else {
          this.cardHeight = 350
        }
      } else {
        this.cardHeight = 450
      }
    },
    searchAvatarSelected(avatarId) {
      const inStandarGroup = this.standarAvatars.find(
        (avatarInPack) => Number(avatarId) === Number(avatarInPack.id)
      )
      if (inStandarGroup === undefined && this.userAvatars) {
        return this.userAvatars.find((userAvatar) => Number(avatarId) === Number(userAvatar.id))
      }
      return this.standarAvatars.find(
        (avatarInPack) => Number(avatarId) === Number(avatarInPack.id)
      )
    },
    setFreeAvatars(data) {
      const freeAvatarPacks = data.filter((item) => item.avatarPackType === 'FREE')
      const freeAvatars = []

      freeAvatarPacks.forEach((avatarPack) => {
        const avatars = avatarPack.avatarDTOList
        const avatarsWithPack = []
        avatars.forEach((element) => {
          const avatar = element
          avatar.avatarPack = { id: avatarPack.id, price: avatarPack.price }
          avatarsWithPack.push(avatar)
        })
        freeAvatars.push(...avatarsWithPack)
      })

      this.standarAvatars = freeAvatars
    },
    setPayAvatars(data) {
      const toPayAvatarPacks = data.filter((item) => item.avatarPackType === 'PAY')
      const payAvatars = []

      toPayAvatarPacks.forEach((avatarPack) => {
        const avatars = avatarPack.avatarDTOList
        const avatarsWithPack = []
        avatars.forEach((element) => {
          const avatar = element
          avatar.avatarPack = { id: avatarPack.id, price: avatarPack.price }
          avatarsWithPack.push(avatar)
        })
        payAvatars.push(...avatarsWithPack)
      })

      this.payAvatars = payAvatars
    },
    toBuy(avatar) {
      this.$emit('purchase', avatar)
    },
    async updateAvatar() {
      this.btnLoading = true
      this.selectedAvatarFromDB = this.selectedAvatar
      await UserAvatarService.selectUserAvatar(this.user.id, this.selectedAvatarFromDB.id)
        .then(() => {
          this.changeAvatar(this.selectedAvatarFromDB)
        })
        .catch((error) => console.error(error))
      this.btnLoading = false
      this.closeModal()
    },
  },
  watch: {
    dialog() {
      if (this.dialog && this.reload > 0) {
        setTimeout(() => {
          this.loadData()
        }, 100)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.color-primary {
  color: #514773;
}
.color-text {
  color: #323A46;
}
.no-uppercase {
  text-transform: none;
}
// .custom7cols {
//   width: 14%;
//   max-width: 14%;
//   flex-basis: 14%;
// }
.title-avatar {
  color: #323A46;
  font-size: 1.75rem;
  @media screen and (max-width: 600px) {
    font-size: 1.2rem;
  }
}
.title-avatar-types{
  color: #323A46;
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: -0.02em;
}
</style>
